import { createOptionsFrom } from "@/lib/common/Option";

export const PriceAlertMetricLabels = {
	FixedValue: "Fixed Value",
	FlatGain: "Flat Gain",
	FlatLoss: "Flat Loss",
	PercentageGain: "Percentage Gain",
	PercentageLoss: "Percentage Loss"
} as const;

export type PriceAlertMetric = keyof typeof PriceAlertMetricLabels;

export const PriceAlertMetricOptions = createOptionsFrom(PriceAlertMetricLabels);

export const priceAlertMetricIsPercentage = (metricType: PriceAlertMetric): boolean => {
	return metricType === "PercentageGain" || metricType === "PercentageLoss";
};

export const priceAlertMetricHasStep = (metricType: PriceAlertMetric): boolean => {
	return metricType !== "FixedValue";
};

export const priceAlertMetricStepIsRequired = (metricType: PriceAlertMetric): boolean => {
	return metricType === "PercentageGain" || metricType === "PercentageLoss";
};
